module.exports = __webpack_public_path__ + "static/media/czhdIMG1.836072ff.png";